import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/aiLibImage/initialState'
import reducers from 'store/features/aiLibImage/reducers'

export const aiLibImageSlice = createSlice({
  name: 'aiLibImage',
  initialState: getInitialState(),
  reducers
})

export default aiLibImageSlice
